import React from 'react'
import { Row, Col } from 'antd'

import { Image, Title } from 'src/components/Ant'
import images from 'src/config/images'

import * as CSS from '../../styles'

function TitleReport({ title }: { title: string }) {
  return (
    <CSS.WrapSectionTitle>
      <Row>
        <Col span={24}>
          <div id="content">
            <Image
              alt="web.login.img.alt"
              id="image"
              src={images.logo}
              title="web.login.img.title"
            />
            <Title id="title" title={title} level={2} />
          </div>
        </Col>
      </Row>
    </CSS.WrapSectionTitle>
  )
}

export default TitleReport
